{
  "title": "Device credentials",
  "addPassword": "Add a password",
  "emptyTitle": "No passwords yet",
  "emptyHint": "A VNC password is entered here once and attached to machines by reference: in a fleet where every machine shares one password, anything else would mean a hundred copies of one secret.",
  "listFailed": "The list is unavailable",
  "deleteFailed": "Deleting failed",
  "editTitle": "Edit the name, the user, or the secret",
  "deleteTitle": "Delete the credential",
  "detachFirst": "Detach it from the nodes first — otherwise their connections would break silently",
  "noVncHint": "There are no VNC passwords yet. Create them on the Credentials screen — from there they attach to every machine that shares a password.",
  "noSshHint": "There are no SSH credentials yet. Create them on the Credentials screen — a password or a private key — and from there they attach to every machine with the same access.",
  "noRtspHint": "There are no RTSP credentials yet. Create them on the Credentials screen — the same place as VNC passwords — and attach them from here.",
  "kind": {
    "vnc": "VNC",
    "rtsp": "RTSP (cameras)",
    "snmp": "SNMP",
    "httpBasic": "HTTP Basic",
    "ssh": "SSH (password)",
    "sshKey": "SSH (private key)"
  },
  "hint": {
    "password": "password",
    "community": "community",
    "privateKey": "private key"
  },
  "column": {
    "username": "User",
    "nodes": "Nodes",
    "createdAt": "Created"
  },
  "form": {
    "nameHint": "How to tell this credential from the others: “Fleet password”, “Branch cameras”",
    "kindFixed": "The kind does not change: it decides how the secret is used, and changing it would break the connections of attached nodes",
    "usernameHint": "VNC Authentication has no username",
    "secret": "Secret",
    "newSecret": "New secret",
    "leaveEmpty": "leave empty to keep the current one",
    "vncTruncatedHint": "The server only checks the first eight characters: that is how the VNC protocol works. Everything past them does not affect the login.",
    "keepSecretHint": "An empty field keeps the current secret. What is stored cannot be read back — only replaced entirely",
    "newSecretHint": "Stored encrypted and never shown again — only replaced entirely",
    "vncTruncatedNote": "The password is longer than {{limit}} characters. VNC Authentication encrypts the challenge with a key made of the first eight bytes and drops the rest: the connection will work with a partial password, and the extra length adds no strength here."
  },
  "none": "no password",
  "fieldLabel": "Credentials"
}
